
// import React, { useState, useEffect, useCallback } from "react";
// import "../CSS/report.css";
// import { FaSearch, FaTimes, FaDownload } from "react-icons/fa";
// import Sidebar from "./Sidebar";
// import axios from "axios"; 
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import logoLeft from "../images/vithalvisionlogo.jpg"; //  Top-left logo
// import logoRight from "../images/blackCinevestor.jpg"; //  Top-right logo

// const API_BASE_URL = "http://localhost:8000/api"; 

// const TransactionHistory = () => {
//     const [searchQuery, setSearchQuery] = useState("");
//     const [transactions, setTransactions] = useState([]); 
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [viewModalVisible, setViewModalVisible] = useState(false);
//     const [selectedTransaction, setSelectedTransaction] = useState(null); 
//     const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//     const [loggedInUserId, setLoggedInUserId] = useState(null); 

//     useEffect(() => {
//         const userId = sessionStorage.getItem("userId");
//         if (userId) setLoggedInUserId(userId);
//         else {
//             setError("User ID not found. Please log in to view history.");
//             setLoading(false);
//         }
//     }, []);

//     const fetchTransactions = useCallback(async () => {
//         if (!loggedInUserId) {
//             setLoading(false);
//             return;
//         }
//         setLoading(true);
//         setError(null);
//         try {
//             const response = await axios.get(`${API_BASE_URL}/transactions/history`, {
//                 params: {
//                     user_id: loggedInUserId,
//                     search_query: searchQuery
//                 }
//             });
//             setTransactions(response.data);
//         } catch (err) {
//             console.error("Error fetching transactions:", err);
//             const detail = err.response?.data?.detail || "An unexpected error occurred.";
//             setError(`Failed to load history: ${detail}`);
//             setTransactions([]);
//         } finally {
//             setLoading(false);
//         }
//     }, [searchQuery, loggedInUserId]); 

//     useEffect(() => {
//         if (loggedInUserId) {
//             const handler = setTimeout(() => {
//                 fetchTransactions();
//             }, 500); 
//             return () => clearTimeout(handler);
//         }
//     }, [searchQuery, loggedInUserId, fetchTransactions]);

//     const openViewModal = (transaction) => {
//         setSelectedTransaction(transaction);
//         setViewModalVisible(true);
//     };

//     const closeModals = () => {
//         setViewModalVisible(false);
//         setSelectedTransaction(null);
//     };

//     const formatAmount = (amount) => {
//         if (amount === null || amount === undefined) return 'N/A';
//         return new Intl.NumberFormat('en-IN', {
//             style: 'currency',
//             currency: 'INR',
//             minimumFractionDigits: 2,
//         }).format(amount);
//     };

//     //  PDF with status highlight
//     const downloadTransactionPDF = (transaction) => {
//         const doc = new jsPDF();

//         // Logos
//         // const logoWidth = 40;
//         // const logoHeight = 20;
//         // doc.addImage(logoLeft, "PNG", 14, 10, logoWidth, logoHeight);
//         // doc.addImage(logoRight, "PNG", 155, 10, logoWidth, logoHeight);
//         doc.addImage(logoLeft, "PNG", 14, 10, 40, 20); // left logo stays same
//         doc.addImage(logoRight, "PNG", 155, 2, 40, 38); // height increased to 30

//         // Company and Platform Names
//         doc.setFontSize(14);
//         doc.setFont("helvetica", "bold");
//         doc.text("Vithal Visions Private Limited", 105, 15, { align: "center" });

//         doc.setFontSize(12);
//         doc.setFont("helvetica", "normal");
//         doc.text("Cinevestor (Platform)", 105, 22, { align: "center" });

//         // Company details (pushed down for top margin)
//         const companyDetails = [
//             "CIN: U59141PN2025PTC237150",
//             "GSTN: 27AAKCV6810E1Z9",
//             // "Registered Address: Daya House Khairlanji Road, Tirora, Dist. Gondia  441911, Maharashtra, India",
//             "Contact Email: legal@cinevestor.in, DPIIT: DIPP188934"
//         ];
//         let y = 35;
//         doc.setFontSize(10);
//         companyDetails.forEach(line => {
//             doc.text(line, 14, y);
//             y += 6;
//         });

//         // Line separator
//         doc.setLineWidth(0.5);
//         doc.line(14, y, 196, y);
//         y += 10;

//         // Transaction Title
//         doc.setFontSize(14);
//         doc.setFont("helvetica", "bold");
//         doc.text("Transaction Details", 14, y);
//         y += 8;

//         // Table with status highlight
//         autoTable(doc, {
//             startY: y,
//             head: [["Field", "Value"]],
//             body: [
//                 ["Order ID", transaction.OrderID],
//                 ["User ID", transaction.UserId],
//                 ["Project ID", transaction.ProjectID || "N/A"],
//                 ["Project Title", transaction.ProjectTitle || "N/A"],
//                 ["Name", transaction.Name],
//                 ["Email", transaction.Email],
//                 ["Mobile", transaction.Mobile || "N/A"],
//                 ["Amount", formatAmount(transaction.Amount)],
//                 ["Status", transaction.Status || "Pending"],
//                 ["Created At", new Date(transaction.CreatedAt).toLocaleString()]
//             ],
//             styles: { fontSize: 11 },
//             headStyles: { fillColor: [41, 128, 185], textColor: 255 },
//             alternateRowStyles: { fillColor: [245, 245, 245] },
//             margin: { left: 14, right: 14 },
//             didParseCell: function (data) {
//                 // Highlight Status
//                 if (data.section === 'body' && data.column.index === 1 && data.row.index === 8) { 
//                     const statusValue = data.cell.raw.toLowerCase();
//                     if (statusValue === 'success') data.cell.styles.fillColor = [46, 204, 113]; // green
//                     else data.cell.styles.fillColor = [231, 76, 60]; // red
//                     data.cell.styles.textColor = 255;
//                 }
//             }
//         });

//         doc.save(`Transaction_${transaction.OrderID}.pdf`);
//     };

//     return (
//         <>
//             <Sidebar
//                 isOpen={isSidebarOpen}
//                 toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
//             />
//             <div className="report-app-container">
//                 <main className="report-main-content">
//                     {/* Header */}
//                     <div className="report-page-header">
//                         <h1 className="report-page-title">
//                             <i className="fas fa-id-card"></i> Transaction History
//                         </h1>
//                         <div className="report-input-group">
//                             <input
//                                 type="search"
//                                 className="report-search-input"
//                                 placeholder="Search by Order ID, Project Title, etc..."
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 disabled={loading || !loggedInUserId} 
//                             />
//                             <button 
//                                 className="report-search-btn" 
//                                 onClick={fetchTransactions}
//                                 disabled={loading || !loggedInUserId}
//                             >
//                                 <FaSearch />
//                             </button>
//                         </div>
//                     </div>

//                     {/* Table */}
//                     <div className="report-table-container">
//                         <table>
//                             <thead>
//                                 <tr>
//                                     <th>Order ID</th>
//                                     <th>Project ID</th> 
//                                     <th>Project Title</th> 
//                                     <th>Name</th>
//                                     <th>Email</th>
//                                     <th>Amount</th>
//                                     <th>Status</th>
//                                     <th>Created At</th>
//                                     <th>Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {loading && (
//                                     <tr>
//                                         <td colSpan="10" style={{ textAlign: "center", padding: "1rem", color: "#666" }}>
//                                             {loggedInUserId ? " Loading transactions..." : " Waiting for User ID..."}
//                                         </td>
//                                     </tr>
//                                 )}
//                                 {!loading && error && (
//                                     <tr>
//                                         <td colSpan="10" style={{ textAlign: "center", padding: "1rem", color: "red", fontWeight: "bold" }}>
//                                              {error}
//                                         </td>
//                                     </tr>
//                                 )}
//                                 {!loading && !error && transactions.length === 0 ? (
//                                     <tr>
//                                         <td colSpan="10" style={{ textAlign: "center", padding: "1rem", color: "#aaa" }}>
//                                              No transaction records found for this user.
//                                         </td>
//                                     </tr>
//                                 ) : (
//                                     transactions.map((transaction) => (
//                                         <tr key={transaction.OrderID}>
//                                             <td data-label="Order ID">{transaction.OrderID.substring(0, 8)}...</td> 
//                                             <td data-label="Project ID">{transaction.ProjectID || 'N/A'}</td> 
//                                             <td data-label="Project Title">{transaction.ProjectTitle || 'N/A'}</td> 
//                                             <td data-label="Name">{transaction.Name}</td>
//                                             <td data-label="Email">{transaction.Email}</td>
//                                             <td data-label="Amount">{formatAmount(transaction.Amount)}</td>
//                                             <td data-label="Status">{transaction.Status || 'Pending'}</td>
//                                             <td data-label="Created At">{new Date(transaction.CreatedAt).toLocaleDateString()}</td>
//                                             <td>
//                                                 <button
//                                                     className="report-view-btn"
//                                                     onClick={() => openViewModal(transaction)}
//                                                 >
//                                                     <FaSearch />
//                                                 </button>
//                                                 <button
//                                                     className="report-download-btn"
//                                                     onClick={() => downloadTransactionPDF(transaction)}
//                                                     style={{ marginLeft: "5px" }}
//                                                 >
//                                                     <FaDownload />
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>

//                     {/* View Modal */}
//                     {viewModalVisible && selectedTransaction && (
//                         <div className="report-modal">
//                             <div className="report-modal-content">
//                                 <span className="report-close" onClick={closeModals}>
//                                     <FaTimes />
//                                 </span>
//                                 <h2>Transaction Details</h2>
//                                 <p><strong>Order ID:</strong> {selectedTransaction.OrderID}</p>
//                                 <p><strong>User ID:</strong> {selectedTransaction.UserId}</p>
//                                 <p><strong>Project ID:</strong> {selectedTransaction.ProjectID || 'N/A'}</p>
//                                 <p><strong>Project Title:</strong> {selectedTransaction.ProjectTitle || 'N/A'}</p>
//                                 <p><strong>Name:</strong> {selectedTransaction.Name}</p>
//                                 <p><strong>Email:</strong> {selectedTransaction.Email}</p>
//                                 <p><strong>Mobile:</strong> {selectedTransaction.Mobile}</p>
//                                 <p><strong>Amount:</strong> {formatAmount(selectedTransaction.Amount)}</p>
//                                 <p><strong>Status:</strong> {selectedTransaction.Status || 'Pending'}</p>
//                                 <p><strong>Created At:</strong> {new Date(selectedTransaction.CreatedAt).toLocaleString()}</p>
//                             </div>
//                         </div>
//                     )}
//                 </main>
//             </div>
//         </>
//     );
// };

// export default TransactionHistory;


import React, { useState, useEffect, useCallback } from "react";
import "../CSS/report.css";
import { FaSearch, FaTimes, FaDownload } from "react-icons/fa";
import Sidebar from "./Sidebar";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logoLeft from "../images/vithalvisionlogo.jpg";
import logoRight from "../images/blackCinevestor.jpg";
import { BASE_API_URL } from "../constants";

//  FIX 1: Remove the incorrect API_BASE_URL
// const API_BASE_URL = "http://localhost:8000/api"; 

const TransactionHistory = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [viewModalVisible, setViewModalVisible] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [loggedInUserId, setLoggedInUserId] = useState(null);
    const [profitSummary, setProfitSummary] = useState(null);

    useEffect(() => {
        const userId = sessionStorage.getItem("userId");
        if (userId && userId !== "undefined") {
            setLoggedInUserId(userId);
        } else {
            setError("User ID not found. Please log in to view history.");
            setLoading(false);
        }
    }, []);

    const fetchTransactions = useCallback(async () => {
        if (!loggedInUserId) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(`${BASE_API_URL}/api/transactions/history`, {
                params: {
                    user_id: loggedInUserId,
                    search_query: searchQuery
                }
            });
            setTransactions(response.data);

            try {
                const profitResp = await axios.get(
                    `${BASE_API_URL}/api/contributions/profit-summary?userId=${loggedInUserId}`
                );
                setProfitSummary(profitResp.data);
            } catch (e) {
                setProfitSummary(null);
            }
        } catch (err) {
            console.error("Error fetching transactions:", err);
            const detail = err.response?.data?.detail || "An unexpected error occurred.";
            setError(`Failed to load history: ${detail}`);
            setTransactions([]);
        } finally {
            setLoading(false);
        }
    }, [searchQuery, loggedInUserId]);
    const getProfitForOrder = (orderId) => {
        if (!profitSummary || !Array.isArray(profitSummary.contributions)) return null;
        return profitSummary.contributions.find((c) => c.id === orderId) || null;
    };

    useEffect(() => {
        if (loggedInUserId) {
            const handler = setTimeout(() => {
                fetchTransactions();
            }, 500);
            return () => clearTimeout(handler);
        }
    }, [searchQuery, loggedInUserId, fetchTransactions]);

    const openViewModal = (transaction) => {
        setSelectedTransaction(transaction);
        setViewModalVisible(true);
    };

    const closeModals = () => {
        setViewModalVisible(false);
        setSelectedTransaction(null);
    };

    const formatAmount = (amount) => {
        if (amount === null || amount === undefined) return 'N/A';
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
        }).format(amount);
    };

    const downloadTransactionPDF = (transaction) => {
        const doc = new jsPDF();
        doc.addImage(logoLeft, "PNG", 14, 10, 40, 20);
        doc.addImage(logoRight, "PNG", 155, 2, 40, 38);

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text("Vithal Visions Private Limited", 105, 15, { align: "center" });

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");
        doc.text("Cinevestor (Platform)", 105, 22, { align: "center" });

        const companyDetails = [
            "CIN: U59141PN2025PTC237150",
            "GSTN: 27AAKCV6810E1Z9",
            "Contact Email: legal@cinevestor.in, DPIIT: DIPP188934"
        ];
        let y = 35;
        doc.setFontSize(10);
        companyDetails.forEach(line => {
            doc.text(line, 14, y);
            y += 6;
        });

        doc.setLineWidth(0.5);
        doc.line(14, y, 196, y);
        y += 10;

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text("Transaction Details", 14, y);
        y += 8;

        autoTable(doc, {
            startY: y,
            head: [["Field", "Value"]],
            body: [
                ["Order ID", transaction.OrderID],
                ["User ID", transaction.UserId],
                ["Project ID", transaction.ProjectID || "N/A"],
                ["Project Title", transaction.ProjectTitle || "N/A"],
                ["Name", transaction.Name],
                ["Email", transaction.Email],
                ["Mobile", transaction.Mobile || "N/A"],
                ["Amount", "Rs. " + Number(transaction.Amount).toFixed(2)],
                ["Status", transaction.PaymentStatus || "Pending"],
                ["Created At", new Date(transaction.CreatedAt).toLocaleString()]
            ],
            styles: { fontSize: 11 },
            headStyles: { fillColor: [41, 128, 185], textColor: 255 },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            margin: { left: 14, right: 14 },
            didParseCell: function (data) {
                if (data.section === 'body' && data.column.index === 1 && data.row.index === 8) {
                    const statusValue = data.cell.raw.toLowerCase();
                    if (statusValue === 'success') data.cell.styles.fillColor = [46, 204, 113];
                    else data.cell.styles.fillColor = [231, 76, 60];
                    data.cell.styles.textColor = 255;
                }
            }
        });

        doc.save(`Transaction_${transaction.OrderID}.pdf`);
    };

    return (
        <>
            <Sidebar
                isOpen={isSidebarOpen}
                toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
            />
            <div className="report-app-container">
                <main className="report-main-content">
                    {/* Header */}
                    <div className="report-page-header">
                        <h1 className="report-page-title">
                            <i className="fas fa-id-card"></i> Transaction History
                        </h1>
                        <div className="report-input-group">
                            <input
                                type="search"
                                className="report-search-input"
                                placeholder="Search by Order ID, Project Title, etc..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                disabled={loading || !loggedInUserId}
                            />
                            <button
                                className="report-search-btn"
                                onClick={fetchTransactions}
                                disabled={loading || !loggedInUserId}
                            >
                                <FaSearch />
                            </button>
                        </div>
                    </div>


                    {/* Table */}
                    <div className="report-table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Order ID</th>
                                    <th>Description</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Returns %</th>
                                    <th>Accrued</th>
                                    <th>Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading && (
                                    <tr>
                                        <td colSpan="10" style={{ textAlign: "center", padding: "1rem", color: "#666" }}>
                                            {loggedInUserId ? " Loading transactions..." : " Waiting for User ID..."}
                                        </td>
                                    </tr>
                                )}
                                {!loading && error && (
                                    <tr>
                                        <td colSpan="10" style={{ textAlign: "center", padding: "1rem", color: "red", fontWeight: "bold" }}>
                                            {error}
                                        </td>
                                    </tr>
                                )}
                                {!loading && !error && transactions.length === 0 ? (
                                    <tr>
                                        <td colSpan="10" style={{ textAlign: "center", padding: "1rem", color: "#aaa" }}>
                                            No transaction records found for this user.
                                        </td>
                                    </tr>
                                ) : (
                                    transactions.map((transaction, idx) => {
                                        const isWallet = transaction.recordType === 'WALLET';
                                        const isCredit = transaction.PaymentStatus === 'CREDIT';
                                        const isDebit = transaction.PaymentStatus === 'DEBIT';
                                        const isSuccess = transaction.PaymentStatus === 'SUCCESS';

                                        const typeLabel = isWallet
                                            ? (isCredit ? 'Wallet Credit' : 'Wallet Debit')
                                            : 'Payment';

                                        const typeColor = isWallet
                                            ? (isCredit ? '#2ecc71' : '#e53170')
                                            : '#3da9fc';

                                        const statusColor = isSuccess ? '#2ecc71'
                                            : isCredit ? '#2ecc71'
                                                : isDebit ? '#e53170'
                                                    : '#f39c12';

                                        const rowKey = isWallet
                                            ? `wallet-${idx}-${transaction.OrderID}`
                                            : transaction.OrderID || idx;

                                        const orderId = transaction.OrderID || '';
                                        const orderIdDisplay = isWallet
                                            ? '—'
                                            : (orderId.length > 8 ? orderId.substring(0, 8) + '...' : orderId);

                                        return (
                                            <tr key={rowKey} style={isWallet ? { background: 'rgba(255,255,255,0.02)' } : {}}>
                                                <td data-label="Type">
                                                    <span style={{
                                                        color: typeColor,
                                                        fontWeight: 700,
                                                        fontSize: '0.8rem',
                                                        background: `${typeColor}18`,
                                                        padding: '3px 10px',
                                                        borderRadius: '999px',
                                                        whiteSpace: 'nowrap'
                                                    }}>
                                                        {typeLabel}
                                                    </span>
                                                </td>
                                                <td data-label="Order ID" style={{ color: '#94a3b8', fontSize: '0.82rem' }}>
                                                    {orderIdDisplay}
                                                </td>
                                                <td data-label="Description">
                                                    {isWallet
                                                        ? transaction.ProjectTitle || transaction.PaymentStatus
                                                        : (transaction.ProjectTitle !== 'N/A' ? transaction.ProjectTitle : (transaction.Name || 'N/A'))}
                                                </td>
                                                <td data-label="Amount" style={{ fontWeight: 600 }}>
                                                    <span style={{ color: isDebit ? '#e53170' : '#2ecc71' }}>
                                                        {isDebit ? '- ' : '+ '}
                                                        {formatAmount(transaction.Amount)}
                                                    </span>
                                                </td>
                                                <td data-label="Status">
                                                    <span style={{
                                                        color: statusColor,
                                                        fontWeight: 600,
                                                        fontSize: '0.82rem'
                                                    }}>
                                                        {transaction.PaymentStatus || 'Pending'}
                                                    </span>
                                                </td>
                                                <td data-label="Returns %">
                                                    {(() => {
                                                        const profit = !isWallet ? getProfitForOrder(transaction.OrderID) : null;
                                                        return profit ? (
                                                            <span className="report-profit-percent-cell">
                                                                {profit.assignedProfitPercent}%
                                                            </span>
                                                        ) : (
                                                            <span style={{ color: '#5a6577' }}>—</span>
                                                        );
                                                    })()}
                                                </td>
                                                <td data-label="Accrued">
                                                    {(() => {
                                                        const profit = !isWallet ? getProfitForOrder(transaction.OrderID) : null;
                                                        return profit ? (
                                                            <span className="report-profit-accrued-cell">
                                                                ₹{Number(profit.cumulativeProfitAmount).toLocaleString("en-IN")}
                                                            </span>
                                                        ) : (
                                                            <span style={{ color: '#5a6577' }}>—</span>
                                                        );
                                                    })()}
                                                </td>
                                                <td data-label="Date">{new Date(transaction.CreatedAt).toLocaleDateString('en-IN')}</td>
                                                <td>
                                                    <button
                                                        className="report-view-btn"
                                                        onClick={() => openViewModal(transaction)}
                                                    >
                                                        <FaSearch />
                                                    </button>
                                                    {!isWallet && (
                                                        <button
                                                            className="report-download-btn"
                                                            onClick={() => downloadTransactionPDF(transaction)}
                                                            style={{ marginLeft: '5px' }}
                                                        >
                                                            <FaDownload />
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* View Modal */}
                    {viewModalVisible && selectedTransaction && (
                        <div className="report-modal">
                            <div className="report-modal-content">
                                <span className="report-close" onClick={closeModals}>
                                    <FaTimes />
                                </span>
                                <h2>Transaction Details</h2>
                                <p><strong>Type:</strong> {selectedTransaction.recordType === 'WALLET' ? `Wallet ${selectedTransaction.PaymentStatus}` : 'Payment'}</p>
                                {selectedTransaction.recordType !== 'WALLET' && (
                                    <>
                                        <p><strong>Order ID:</strong> {selectedTransaction.OrderID}</p>
                                        <p><strong>Project ID:</strong> {selectedTransaction.ProjectID || 'N/A'}</p>
                                        <p><strong>Project Title:</strong> {selectedTransaction.ProjectTitle || 'N/A'}</p>
                                        <p><strong>Name:</strong> {selectedTransaction.Name}</p>
                                        <p><strong>Email:</strong> {selectedTransaction.Email}</p>
                                        <p><strong>Mobile:</strong> {selectedTransaction.Mobile || 'N/A'}</p>
                                    </>
                                )}
                                {selectedTransaction.recordType === 'WALLET' && (
                                    <>
                                        <p><strong>Reason:</strong> {selectedTransaction.ProjectTitle || 'N/A'}</p>
                                        {selectedTransaction.ProjectID && selectedTransaction.ProjectID !== 'N/A' && (
                                            <p><strong>Related Order:</strong> {selectedTransaction.ProjectID}</p>
                                        )}
                                    </>
                                )}
                                <p><strong>Amount:</strong> {formatAmount(selectedTransaction.Amount)}</p>
                                <p><strong>Status:</strong> {selectedTransaction.PaymentStatus}</p>
                                <p><strong>Date:</strong> {new Date(selectedTransaction.CreatedAt).toLocaleString()}</p>
                            </div>
                        </div>
                    )}
                </main>
            </div>
        </>
    );
};

export default TransactionHistory;